export default __webpack_public_path__ + "static/media/text-field-width.090d43a2.png";